import MetabaseDashboardView from './MetabaseDashboardView';

export default MetabaseDashboardView;
